import CyclesByOperatorPanel from 'src/components/material/DeviceDashboard/CyclesByOperator/CyclesByOperatorPanel'
import React from 'react'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectCyclesByFacilities } from '../summaryDashboardSlice';

const CyclesByOperatorContainer = () => {
    const { t } = useTranslation("translations");
    const {
        cycles,
        selectedFacilities,
    } = useSelector(
        // @ts-ignore
        (store) => store.summarydashboard
    );

    const filteredCycles = useSelector((store) => selectCyclesByFacilities(store.summarydashboard, selectedFacilities.map(facility => facility.name)));

    const loading = useSelector((store) => store.summarydashboard.loading.cyclesByOperator);


    return (
        <CyclesByOperatorPanel deviceCycles={filteredCycles} loading={loading} />
    )
}

export default CyclesByOperatorContainer
